import React from "react";
import moment from "moment";
import {Button, Card, CardContent, Chip, Typography} from "@material-ui/core";
import ReactLinkify from "react-linkify";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Timeline} from "../components/timeline.jsx";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import List from "@material-ui/core/List/List";

function AttachmentList(props){
   if(!props.listItems || props.listItems.length === 0) return(<div />);

   let rows = props.listItems.map((listItem, index) => {

      return (
         <ListItem key={index}>
            <ListItemAvatar>
               <Avatar>
                  <FontAwesomeIcon icon={['far',"file"]} />
               </Avatar>
            </ListItemAvatar>
            <ListItemLink href={listItem.url}>
               <ListItemText primary={listItem.fileName} />
            </ListItemLink>
         </ListItem>
      )
   });

   return(
      <List dense={false}>
         {rows}
      </List>
   )
}

function DescriptionList(props){
   if(!props.listItems || props.listItems.length === 0) return(<div />);
   let rows = props.listItems.map((listItem, index) => {
      return (
         <Button key={index} style={{marginRight:'5px'}} onClick={() => props.onClick(index)} variant='outlined'>{moment(listItem.creationTime).calendar()}</Button>
      )
   });
   return(
      <div id={'incubatorDescriptionList'}>
         {
            (props.listItems && props.listItems.length > 0) &&
            <Typography variant="h5" component="h2" color='primary' className='incubator-card-name' gutterBottom>
               Evolving Overview Versions
            </Typography>
         }
         <List dense={false}>
            {rows}
         </List>
      </div>

   )
}

function ListItemLink(props) {
   return <ListItem button component="a" {...props} />;
}

export class OverviewTab extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         curDescription: 0,
      }
   }
   isIncubatorClosed(date) {
      return (moment(new Date(date)).isBefore(new Date()));
   }

   render() {
      let { portfolio, attachments, descriptions } = this.props;
      let description = descriptions ? descriptions[this.state.curDescription].text:portfolio.description;
      let userAvatarCount = portfolio.contributedUsers.filter(cur => cur.hasAvatar).length - 3;
      let incubatorClosed = this.isIncubatorClosed(portfolio.incubatorEndTime ? portfolio.incubatorEndTime : portfolio.proposalDueTime)
      let sponsorDisplayName = portfolio.sponsorDisplayName ? portfolio.sponsorDisplayName.toUpperCase() : ''
      let customTimelineItems = null;
      if (portfolio.name === 'Dash to Accelerate Health Outcomes'){
         customTimelineItems = [
            {
               title: 'Submissions Open',
               subtitle: 'March 29, 2023',
               enabled: true,
               time: new Date('2023-03-29T12:00:00'),
            },
            {
               title: 'Submissions Close',
               subtitle: 'April 7, 2023',
               enabled: true,
               time: new Date('2023-04-07T12:00:00'),
            },
            {
               title: 'Brackets Published',
               subtitle: 'April 17, 2023',
               enabled: true,
               time: new Date('2023-04-17T12:00:00'),
            }
         ]
      }
      if (portfolio.name === 'Government-University-Industry-Philanthropy Research Roundtable'){
         customTimelineItems = [
            {
               title: 'Workshop Starts',
               subtitle: 'July 21, 2025',
               enabled: true,
               time: new Date('2025-07-21T10:00:00'),
            },
            {
               title: 'Finals Complete',
               subtitle: 'July 25, 2025',
               enabled: true,
               time: new Date('2025-07-25T15:00:00'),
            }
         ]
      }
      return (
         <Card id={'incubatorOverviewTab'}>
            <ReactLinkify componentDecorator={(decoratedHref, decoratedText, key) => (
               <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
               </a>
            )}>
               <div className={'incubator-column-1'} >
                  <Chip
                     className={'incubator-status-chip'}
                     style={{float:'right'}}
                     color={incubatorClosed?'default':'primary'}
                     label={incubatorClosed?'Closed':'Active'}
                  >
                  </Chip>
                  {
                     sponsorDisplayName &&
                     <div className='incubator-card-sponsor'>
                        <Typography color="textSecondary" style={{ fontSize: '12px',color: '#3f51b5' }}>
                           BY:
                        </Typography>
                        <Typography component="p" style={{ marginBottom: '1em' }}>
                           {`${sponsorDisplayName}`}
                        </Typography>
                     </div>
                  }
                  <h2 color='primary' className='incubator-overview-header'>
                     Overview
                  </h2>
                  <p style={{whiteSpace: 'pre-wrap'}}>
                     {description}
                  </p>
                  <br></br>
                  {(attachments && attachments.length > 0) &&
                     <Typography
                        id={'attachmentListTitle'}
                        variant="h5"
                        component="h2"
                        color='primary'
                        className='incubator-card-name'
                        gutterBottom
                     >
                        Attachments
                     </Typography>
                  }
                  <AttachmentList listItems={attachments}/>

                  <DescriptionList
                     listItems={this.props.descriptions}
                     onClick={(index) => this.setState({curDescription: index})}
                  />

                  <Button
                     className={'export-incubator-discussion'}
                     href={'incubator/exportAsDocX?idIncubator=' + this.props.portfolio.id}
                     startIcon={<FontAwesomeIcon icon={['far', "file-word"]}/>}
                     style={{marginTop:'1em'}}
                  >
                     Export Workshop Discussion
                  </Button>
               </div>
               {/* Right Side */}
               <div className={'incubator-column-2'}>
                  <Card>
                     <CardContent>
                        <h2 id={'importantDatesHeader'}>
                           Important Dates
                        </h2>
                        <Timeline
                           orientation="vertical"
                           portfolio={portfolio}
                           items={customTimelineItems}
                        />
                     </CardContent>
                  </Card>

                  <br></br>
                  <div className='portfolio-right-side'>
                     <div className='portfolio-list-card-avatars'>
                        {userAvatarCount > 0 && <span className="portfolio-list-card-avatar-text">&nbsp;&nbsp;&nbsp;+{userAvatarCount}</span>}
                        {
                           portfolio.contributedUsers.filter(cur => cur.hasAvatar).slice(0, 3).map(cur => {
                                 return (
                                    <span key={cur.idUser} className="portfolio-list-card-avatar">
                                          <img src={window.globals.USER_UPLOADS_BASE_URL + '/' + cur.idUser + '/Avatar.png'} width="20" height="20" />
                                       </span>
                                 );
                              }
                           )
                        }
                     </div>
                     {
                        portfolio.lastUpdateTime &&
                        <Typography color="textSecondary" style={{ fontSize: '12px', textAlign: 'left' }}>
                           {`Updated: ${moment(new Date(portfolio.lastUpdateTime)).calendar()}`}
                        </Typography>
                     }
                  </div>
               </div>
            </ReactLinkify>
         </Card>
      );
   }

}